import { Component } from 'react';

class ScrollToTop extends Component {
  componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  }

  render() {
    return null;
  }
}

export default ScrollToTop;
